var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { HDSButton } from "@here/hds-react-components/Button";
import { HDSIcon } from "@here/hds-react-components/Icon";
import { HDSTooltip } from "@here/hds-react-components/Tooltip";
import "../ListView/listView.scss";
import DropDown from "../../components/dropDown/DropDown";
import translations from "../../translations/resources/en-GB.json";
import { copyCollectionUrl, disableDropdownItems, downloadCollection, downloadStubLinkReport, isSharedCollectionHrn, mapDetails, refreshCollection, viewQAReport, viewReport, } from "./helper";
import indoorHelper from "../../store/helpers/indoorHelper";
import { MAP_COLLECTIONS_TAB_LISTING, MAP_COLLECTION_DROPDOWN_VALUES, MAP_COLLECTION_TABLE_HEADERS, selectDropdownList, } from "./constants";
import { Table, Text } from "../../generic-components/Table";
var MapCollectionPage = function (_a) {
    var collectionMetaList = _a.collectionMetaList;
    var dispatch = useDispatch();
    var history = useHistory();
    var user = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.user.info; });
    var copyIconStyle = {
        "--hds-icon-color": "var(--hds-action)",
    };
    var internalToolsFunctionlities = function (item, hrn) {
        if (item === MAP_COLLECTION_DROPDOWN_VALUES.DOWNLOAD_COLLECTION) {
            dispatch(downloadCollection(hrn, indoorHelper.notify));
        }
        else if (item === MAP_COLLECTION_DROPDOWN_VALUES.REFRESH_COLLECTION) {
            dispatch(refreshCollection(hrn, indoorHelper.notify));
        }
        else if (item === MAP_COLLECTION_DROPDOWN_VALUES.DOWNLOAD_CHECKIN_REPORT) {
            dispatch(viewReport(hrn, indoorHelper.notify));
        }
        else if (item === MAP_COLLECTION_DROPDOWN_VALUES.VIEW_QA_REPORT) {
            dispatch(viewQAReport(hrn, indoorHelper.notify));
        }
        else if (item === MAP_COLLECTION_DROPDOWN_VALUES.DOWNLOAD_STUB_LINK_REPORT) {
            dispatch(downloadStubLinkReport(hrn, indoorHelper.notify));
        }
    };
    var Icon = function () {
        return (_jsx(HDSButton, { variant: "secondary", icon: "overflow-vert-center", size: "small" }));
    };
    var cells = {
        collectionShare: function (item) { return (_jsx("div", __assign({ className: "collectionSharedIcon" }, { children: isSharedCollectionHrn(item.hrn, user.realm) && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ id: CSS.escape(item.hrn) }, { children: _jsx(HDSIcon, { name: "people", category: "misc", size: "16px" }) })), _jsx(HDSTooltip, __assign({ trigger: "#".concat(CSS.escape(item.hrn)), placement: "top" }, { children: MAP_COLLECTIONS_TAB_LISTING.SHARED_COLLECTION.LABEL }))] })) }))); },
        collectionName: function (item) { return (_jsx(Text, { classes: "collectionName", value: item.name })); },
        collectionHrn: function (item) { return (_jsxs("div", __assign({ className: "collectionDetails" }, { children: [_jsxs("div", __assign({ id: CSS.escape(item.hrn), className: "collectionUrl", onClick: function () { return copyCollectionUrl(item.hrn, indoorHelper.notify); } }, { children: [_jsx(HDSButton, __assign({ variant: "link" }, { children: MAP_COLLECTIONS_TAB_LISTING.COLLECTION_HRN.DATA })), _jsx(HDSIcon, { name: "copy", category: "file", size: "16px", style: copyIconStyle })] })), _jsx(HDSTooltip, __assign({ trigger: "#".concat(CSS.escape(item.hrn)), placement: "right" }, { children: item.hrn }))] }))); },
        mapCount: function (item) { return (_jsx(Text, { classes: "collectionDetails", value: item.mapsInCollection.length })); },
        lastUpdated: function (item) { return (_jsx(Text, { classes: "collectionDetails", value: item.snapShotDate })); },
        collectionDetails: function (item) { return (_jsx("div", __assign({ className: "collectionDetails" }, { children: _jsxs("div", __assign({ className: "detailsButton" }, { children: [_jsx(HDSButton, __assign({ id: "map-update", variant: "secondary", type: "button", size: "small", width: "103px", onClick: function () {
                            return dispatch(mapDetails(item.hrn, collectionMetaList, history));
                        } }, { children: translations.data["venonboard.mapCollection.detailsButton"] })), _jsx(DropDown, { itemList: selectDropdownList(item.qaReportExists, user.realm), trigger: _jsx(Icon, {}), displayListItemIcon: false, onChange: function (elem) {
                            internalToolsFunctionlities(elem, item.hrn);
                        }, disabledItemList: disableDropdownItems(item.hrn, user.realm) })] })) }))); },
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "collectionSubheading" }, { children: MAP_COLLECTIONS_TAB_LISTING.SUBHEADING.LABEL })), _jsx("div", __assign({ className: "collectionBox" }, { children: _jsx(Table, { columns: MAP_COLLECTION_TABLE_HEADERS, rows: collectionMetaList, cells: cells }) }))] }));
};
export default MapCollectionPage;
